export function parseCustomMenu(raw) {
    if (!raw) {
        return { items: [], bottomItemId: null };
    }

    try {
        const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
        const items = Array.isArray(data.items)
            ? data.items.filter(item => item?.id && item?.title && item?.url)
            : [];
        const bottomItemId = items.some(item => item.id === data.bottomItemId)
            ? data.bottomItemId
            : null;

        return { items, bottomItemId };
    } catch {
        return { items: [], bottomItemId: null };
    }
}

export function normalizeIframeUrl(url) {
    const value = (url || '').trim();
    if (!value) {
        return '';
    }

    if (/^https?:\/\//i.test(value)) {
        return value;
    }

    if (value.startsWith('//')) {
        return `https:${value}`;
    }

    return `https://${value}`;
}

export function appendQueryParam(url, key, value) {
    if (!url || value == null || value === '') {
        return url;
    }

    try {
        const parsed = new URL(url);
        parsed.searchParams.set(key, String(value));
        return parsed.toString();
    } catch {
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }
}

export function buildIframeUrl(url, clientId) {
    const normalized = normalizeIframeUrl(url);
    if (!normalized) {
        return '';
    }

    return clientId ? appendQueryParam(normalized, 'clientId', clientId) : normalized;
}

export function getCustomSectionRoute(id) {
    return `/section/${id}`;
}

export function goToCustomSection(router, id) {
    if (!id) {
        return;
    }

    router.push(getCustomSectionRoute(id));
}

export function getBottomMenuItem(menu) {
    if (!menu?.bottomItemId) {
        return null;
    }

    return menu.items.find(item => item.id === menu.bottomItemId) || null;
}

export function getCustomMenuItem(menu, id) {
    if (!menu?.items?.length || !id) {
        return null;
    }

    return menu.items.find(item => item.id === id) || null;
}
